import { USER_BONUS_TABLE_ES_MX } from "#components/tables/reports/user-bonus-table/translations/user-bonus-table-es-mx";
import { TRANSACTIONS_REPORT_ES_MX } from "#components/transactions-report/translations";
import { BONUS_CATEGORIES_ES_MX } from "#pages/place/bonus-categories/translations";
import { CATERING_ES_MX } from "#pages/place/catering/translations/catering-es-mx";
import { EXTRACT_ES_MX } from "#pages/place/extract-new/translations/extract-es-mx";
import { BONUS_REPORT_FOR_PLACE_ES_MX } from "#pages/place/financial-reports/bonus-report-for-place/translations";
import { BONUS_REPORT_ES_MX } from "#pages/place/financial-reports/bonus-report/translations";
import { USED_BONUS_REPORT_ES_MX } from "#pages/place/financial-reports/bonus-report/used-bonus-report/translations";
import { precharge_ES_MX } from "#pages/place/precharge/pages/translations";
import { IMPORT_ES_MX } from "#pages/place/purchase-invoice/import-invoice/translations/import-es-mx";
import { PURCHASE_INVOICE_ES_MX } from "#pages/place/purchase-invoice/translations/purchase-invoice-es-mx";
import { WIZARD_ES_MX } from "#pages/place/wizard/translations/wizard-es-mx";
import { audits } from "./audits";
import { barReports } from "./bar-reports";
import { barsAndSectors } from "./bars-and-sectors";
import { businessIntelligence } from "./business-intelligence/";
import { coala } from "./coala";
import { contracts } from "./contracts";
import { delivery } from "./delivery";
import { discountCategory } from "./discount-category";
import { emissionErrors } from "./emission-errors";
import { emited } from "./emited";
import { entrance } from "./entrance";
import { entranceBilling } from "./entrance-billing/";
import { events } from "./events/";
import { extract } from "./extract";
import { financialReport } from "./financial-report/";
import { fiscalReport } from "./fiscal-report";
import { guestList } from "./guest-list/";
import { importXml } from "./import-xml";

import { inventoryControl } from "./inventory-control";
import { invoicesBackups } from "./invoices-backups";
import { invoicesIva } from "./invoices-iva";
import { invoicesNational } from "./invoices-national";
import { kardex } from "./kardex";
import { kds } from "./kds";
import { manageDevices } from "./manage-devices";
import { multivendor } from "./multivendor";
import { notEmitedProducts } from "./not-emited-products";
import { passwordCard } from "./password-card";
import { placeData } from "./place-data";
import { pos } from "./pos";
import { prechargeReports } from "./precharge-reports";
import { productMenu } from "./product-menu";
import { products } from "./products";
import { productArea } from "./products/product-area";
import { productDetail } from "./products/product-detail";
import { promotion } from "./promotion";
import { promotions } from "./promotions";
import { rechargeManagement } from "./recharge-management";
import { recharges } from "./recharges";
import { reserve } from "./reserve";
import { reserveV2 } from "./reserve-v2";
import { search } from "./search";
import { settings } from "./settings";
import { storage } from "./storage/";
import { tagGroups } from "./tag-groups";
import { TRANSACTIONS_ES_MX } from "./transactions";
import { whatsUp } from "./whats-up";

export const placeES_MX = {
	placeTitle: "Locales",
	insights: {
		previewTitle: "INSIGHTS RECIENTES",
		viewAll: "Ver todos los insights",
		pageTitle: "Insights y Sugerencias",
		pageSubtitle: "Recomendaciones generadas automáticamente para su operación.",
		backToPlaces: "Volver a Locales",
		all: "Todos",
		noInsights: "No hay insights disponibles en este momento.",
		insightCount: "insight",
		insightCountPlural: "insights",
		updatedAt: "Actualizado en:",
		groupedPlacesChip: "Aparece en {{count}} locales",
		closeDrawer: "Cerrar",
		unknownPlace: "Local desconocido",
	},
	placeWithoutEvent: "Locales sin evento por más de un mes",
	placeWithOpenEvent: "Locales con evento en curso",
	placeWithoutEventInProgress: "Locales sin evento en curso",
	searchPlaceInputPlaceholder: "Buscar local",
	timezone: "Zona horaria",
	currency: "Moneda",
	subtitle: "Leyenda",
	alphabeticalOrder: "Orden alfabético",
	lastEventOrder: "Último evento creado",
	initialDefaultDateOrder: "Filtro predeterminado de fechas",
	financialFile: {
		title: "Archivo financiero",
		description: "Dé seguimiento a sus solicitudes de equipos y suscripciones.",
		titleDescription: "Descripción",
		downloadButton: "Descargar",
		table: {
			columns: {
				name: "Nombre",
				contractId: "ID del contrato",
				period: "Período",
			},
		},
		eventType: {
			festival: "Festival",
			fixedVenue: "Local Fijo",
			event: "Evento",
			sports: "Deportivo",
			fairs: "Ferias",
			beachClub: "Beach Club",
			retail: "Retail",
			bar: "Bar",
			others: "Otros",
			hotel: "Hotel",
			restaurant: "Restaurante",
			school: "Escuela",
			arena: "Arena (Estadio)",
			hospitality: "Hospitality",
			nightclub: "Antro",
			barRestaurant: "Bar & Restaurante",
			beachTennisCourt: "Cancha de Beach Tennis",
			carnival: "Carnaval",
			juneParty: "Fiesta de San Juan",
			musicFestival: "Festival de Música",
			show: "Show",
			newYearsEve: "Año Nuevo",
			eventVenue: "Local de eventos",
			musicShow: "Show de música",
			sportsEvent: "Evento deportivo",
			gastronomicEvent: "Evento Gastronómico",
			religiousEvent: "Evento religioso",
			schoolEvent: "Evento escolar",
			seasonalHouse: "Local de Temporada",
		},
		eventModel: {
			monthly: "Mensual",
			weekly: "Semanal",
			oneTime: "Individual",
		},
		invoiceType: {
			daily: "Diario",
			weekly: "Semanal",
			monthly: "Mensual",
			atTermination: "Al Término",
			perSession: "Por Sesión",
		},
		financialClosingTitle: "Cierre Financiero",
		zigDataSection: "Datos - Zig",
		currency: "Moneda",
		document: "Documento",
		name: "Nombre",
		address: "Dirección",
		eventDataSection: "Datos - Evento",
		period: "Período",
		notInformed: "No informado",
		type: "Tipo",
		zigExecutive: "Ejecutivo Zig",
		model: "Modelo",
		billing: "Facturación",
		automaticRepayment: "Reembolso Automático",
		yes: "Sí",
		no: "No",
		placeId: "PlaceId",
		organizationId: "OrganizationId",
		clientDataSection: "Datos - Cliente",
		client: "Cliente",
		contract: "Contrato",
		contractValidity: "Vigencia del Contrato",
		eventBillingHeader: "Facturación - Evento",
		value: "Valor",
		total: "Total",
		totalBilling: "Facturación Total",
		zigBillingHeader: "Facturación - Zig",
		item: "Ítem",
		base: "Base",
		taxRate: "Tasa (%)",
		zigInvoiceSummary: "Resumen Factura Zig",
		finalResultHeader: "Resultado Final",
		integratedAcquiringBalance: "Saldo generado por Adquirencia Integrada",
		nonIntegratedAcquiringBalance: "Saldo generado por Adquirencia No Integrada",
		zigInvoice: "Factura Zig",
		balanceToTransfer: "Saldo a Transferir",
		finalBalanceToTransfer: "Saldo Final a Transferir",
		technicalAnalysisHeader: "Análisis Técnico",
		previousValue: "Valor Anterior",
		newValue: "Nuevo Valor",
		issuance: "Emisión",
		date: "Fecha",
		version: "Versión",
		meta: "Meta",
		other: "Otros",
		eventEntries: "Registros - Evento",
		totalBalance: "Total Final",
		tpvOthers: "TPV Otros",
		integratedAcquiring: "Adquirencia Integrada",
		nonIntegratedAcquiring: "Adquirencia No Integrada",
		zigBilling: "Facturación ZIG",
		balanceMovement: "Movimiento de saldo",
		to: "a",
	},
	subtitles: {
		onGoingEvent: "Evento en curso",
		recentEvent: "Evento reciente",
		longTimeWithoutEvent: "Largo tiempo sin evento",
		waitingForApproval: "Esperando Aprobación",
		noEvent: "Sin evento",
	},
	placelinks: {
		post: "Post",
		pre: "Pre",
		noEvents: "Sin eventos",
		none: "Ningún evento",
		openEvent: "Evento abierto",
	},
	placeTabs: {
		products: "Productos",
		combos: "Combos",
		supplies: "Insumos",
		bars: "Bares",
		beer: "Cerveza de barril",
		gng: "Grab and Go",
		cmv: "Ing. de menú",
		config: "Configuraciones de menús",
		catering: "Catering",
	},
	events,
	products,
	productMenu,
	businessIntelligence,
	entranceBilling,
	tagGroups,
	reserve,
	reserveV2,
	storage,
	financialReport,
	guestList,
	entrance,
	pos,
	promotions,
	whatsUp,
	audits,
	settings,
	precharge: precharge_ES_MX,
	barReports,
	extract,
	passwordCard,
	notEmitedProducts,
	promotion,
	search,
	transactions: TRANSACTIONS_ES_MX,
	invoicesIva,
	invoicesNational,
	invoicesBackups,
	kardex,
	multivendor,
	coala,
	discountCategory,
	emissionErrors,
	emited,
	fiscalReport,
	importXml,
	productDetail,
	productArea,
	inventoryControl,
	prechargeReports,
	contracts,
	rechargeManagement,
	recharges,
	transactionsReport: TRANSACTIONS_REPORT_ES_MX,
	bonusCategories: BONUS_CATEGORIES_ES_MX,
	kds,
	purchaseInvoiceV2: PURCHASE_INVOICE_ES_MX,
	import: IMPORT_ES_MX,
	delivery,
	extractNew: EXTRACT_ES_MX,
	usedBonusReport: USED_BONUS_REPORT_ES_MX,
	userBonusTable: USER_BONUS_TABLE_ES_MX,
	bonusReport: BONUS_REPORT_ES_MX,
	bonusReportForPlace: BONUS_REPORT_FOR_PLACE_ES_MX,
	placeData,
	barsAndSectors,
	managerOrders: {
		orderDetailModal: {
			title: "Detalles del pedido",
			orderNumber: "Pedido n.º #{{orderNumber}}",
			nameLabel: "Nombre",
			dateLabel: "Día y hora",
			dateValue: "{{date}} a las {{hour}}",
			originLabel: "Origen del pedido",
			refuseOrder: "Rechazar pedido",
			acceptOrder: "Aceptar pedido",
			cancelOrder: "Cancelar pedido",
			readyOrder: "Marcar como listo",
			dispatchOrder: "Despachar pedido",
			concludeOrder: "Concluir pedido",
			itemsTitle: "Artículos del pedido",
			totalLabel: "Total del pedido",
			deliveryFeeLabel: "Tarifa de envío",
			additionalFeeLabel: "Tarifa de pedido mínimo",
			discountLabel: "Descuento",
			obsLabel: "Observación",
			obsTitle: "Observaciones adicionales",
			deliveryDetailsTitle: "Detalles de entrega",
			paymentMethodLabel: "Método de pago",
			paymentMethodCardValue: "Tarjeta",
			changeBackLabel: "Cambio a devolver",
			deliveryTypeLabel: "Tipo de entrega",
			deliveryByStoreValue: "Entrega por la tienda",
			deliveryByPlatformValue: "Entrega por la plataforma",
			locatorLabel: "Localizador",
			needCutleryLabel: "Cubiertos",
			needCutleryYes: "El cliente solicitó cubiertos",
			addressLabel: "Dirección",
			contactLabel: "Contacto",
			cpfLabel: "CPF",
			phoneLabel: "Teléfono",
			unknownLabel: "Documento desconocido",
			unknown: "No proporcionado",
			printOrder: "Imprimir pedido",
		},
		refuseOrderConfirmation: {
			title: "Rechazar pedido",
			message: "¿Estás seguro de que deseas rechazar este pedido?",
			confirmButton: "Rechazar",
			secondaryMessage: "Esta acción no se puede deshacer.",
		},
	},
	catering: CATERING_ES_MX,
	manageDevices,
	wizard: WIZARD_ES_MX,
};
